import { createAsyncThunk } from "@reduxjs/toolkit";
import { SLICE_NAME } from "utils/constants";

import { singleEvidenceSliceApi } from "./services";
import { singleEvidenceActions } from "./slice";

export const saveColumnsInfo = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/saveColumnsInfo`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.saveColumnsInfo(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getColumnsInfo = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/getColumnsInfo`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.getColumnsInfo(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getEvidenceStatus = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/getEvidenceStatus`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.getEvidenceStatus(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const setEvidenceStatus = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/setEvidenceStatus`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.setEvidenceStatus(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getEvidencesSales = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/getEvidencesSales`,
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await singleEvidenceSliceApi.getEvidencesSales(data);
      dispatch(singleEvidenceActions.setFilteredBody(data));
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getSaveComps = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/getSaveComps`,
  async (params, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.getSaveComps(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getLeftBarValues = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/getLeftBarValues`,
  async (params, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.getLeftBarValues(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const saveComps = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/saveComps`,
  async (body, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.saveComps(body);

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const resetComps = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/resetComps`,
  async (body, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.saveComps(body);

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const exportCompsCsv = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/exportCompsCsv`,
  async (params, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.exportCsv(params);
      const href = URL.createObjectURL(response.data);

      return href;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getEvidencesEquities = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/getEvidencesEquities`,
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await singleEvidenceSliceApi.getEvidencesEquities(data);
      dispatch(singleEvidenceActions.setFilteredBody(data));
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getCompsFilters = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/getCompsFilters`,
  async (params, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.getCompsFilters(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getSubjectProperty = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/getSubjectProperty`,
  async (params, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.getSubjectProperty(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const saveFilters = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/saveFilters`,
  async (body, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.saveFilters(body);

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const resetFilters = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/resetFilters`,
  async (body, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.saveFilters(body);

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getAppliedFilters = createAsyncThunk(
  `${SLICE_NAME.singleEvidenceSlice}/getAppliedFilters`,
  async (params, { rejectWithValue }) => {
    try {
      const response = await singleEvidenceSliceApi.getAppliedFilters(params);

      return response.data.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
